import React from "react";
import { Area } from "../types";
import { PriorityIndicator } from "./PriorityIndicator";
import { TextWithGlossary } from "./TextWithGlossary";

interface PriorityChartProps {
	areas: Area[];
}

export const PriorityChart: React.FC<PriorityChartProps> = ({ areas }) => {
	const counts = {
		high: areas
			.filter((area) => area.priority !== "loading")
			.flatMap((area) => area.actions)
			.filter((action) => action.priority === "high").length,
		medium: areas
			.filter((area) => area.priority !== "loading")
			.flatMap((area) => area.actions)
			.filter((action) => action.priority === "medium").length,
		low: areas
			.filter((area) => area.priority !== "loading")
			.flatMap((area) => area.actions)
			.filter((action) => action.priority === "low").length,
	};

	const max = Math.max(...Object.values(counts));

	const priorityLabel = {
		high: "Alta",
		medium: "Média",
		low: "Baixa",
	};

	return (
		<div className="bg-gray-800 rounded-xl shadow-lg p-6">
			<h3 className="text-lg font-semibold text-white mb-6">
				<TextWithGlossary>
					Distribuição de Ações por Prioridade
				</TextWithGlossary>
			</h3>
			<div className="space-y-4">
				{(["high", "medium", "low"] as const).map((priority) => (
					<div key={priority} className="flex items-center gap-3">
						<div className="flex items-center gap-2 w-24">
							<PriorityIndicator priority={priority} />
							<span className="text-sm text-gray-400">
								{priorityLabel[priority]}
							</span>
						</div>
						<div className="flex-1 h-6 bg-gray-700 rounded-full overflow-hidden">
							<div
								className={`h-full ${
									priority === "high"
										? "bg-red-500"
										: priority === "medium"
										? "bg-yellow-500"
										: "bg-green-500"
								} transition-all duration-500`}
								style={{ width: `${(counts[priority] / max) * 100}%` }}
							/>
						</div>
						<span className="text-sm font-medium text-gray-300 w-8 text-right">
							{counts[priority]}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};
